import { useCallback, useState } from 'react'

const useModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const toggleModal = useCallback(() => {
    setIsModalOpen((oldState) => !oldState)
  }, [])

  return {
    isModalOpen,
    closeModal,
    openModal,
    toggleModal
  }
}

export default useModal
